<template>
	<section>
		<p class="label">{{ header }}</p>
		<form @submit.prevent="onSubmit" :class="{ is_sending: isSending }">
			<div>
				<input
					type="email"
					v-model="email"
					:disabled="isSending"
					:placeholder="placeholderCheck"
					@focus="onFocus"
					@blur="onBlur"
				/>
				<IconInputBg :fill="color" />
				<button
					type="submit"
					v-show="status !== 'success'"
					@mouseenter="onPointerMouseEnter($event)"
					@mouseleave="onPointerMouseLeave($event)"
				>
					<IconArrow :fill="arrowColor" />
				</button>
				<span class="tick" v-show="status === 'success'">
					<IconTick fill="#000" />
				</span>
			</div>
		</form>
		<p style="margin-top: 5px;max-width: 272px;" :style="{ color: color }" v-if="response">{{ response }}</p>
	</section>
</template>

<script>
import axios from "axios";
import IconArrow from "@/components/icons/IconArrow";
import IconTick from "@/components/icons/IconTick";
import IconInputBg from "@/components/icons/IconInputBg";
import pointerHove from "@/mixins/pointerHover";
import { mapState } from "vuex";

export default {
	name: "mailchimp-signup",
	mixins: [pointerHove],
	components: {
		IconTick,
		IconArrow,
		IconInputBg,
	},
	props: {
		label: {
			type: String,
			default: "Signup",
		},
		header: {
			type: String,
			default: "Signup",
		},
		error: {
			type: String,
			default: "There was an Issue signing up you into our mailing list. Please try again later.",
		},
		placeholder: {
			type: String,
			default: "E-mail address",
		},
		url: String,
	},
	data() {
		return {
			isSending: false,
			isFocus: false,
			status: "",
			email: "",
			response: "",
			signUpActionName: "mailchimp_signup",
			languagesArray: {
				en: "english ",
				de: "deutsch",
				fr: "français",
				it: "italiano",
			},
		};
	},
	computed: {
		...mapState({
			currentLanguage: (state) => state.site.currentLanguage,
		}),
		axiosUrl() {
			return `${this.url}admin-ajax.php?action=${this.signUpActionName}`;
		},
		language() {
			return this.languagesArray[this.currentLanguage];
		},
		color() {
			let col = "#ffffff";
			if (this.isFocus) col = "#EEDBCE";
			if (this.status === "success") col = "#EEDBCE";
			if (this.status === "error") col = "#FF3D37";

			return col;
		},
		arrowColor() {
			let col = "#7C7A78";
			if (this.isFocus) col = "#000";
			if (this.status === "success") col = "#000";
			if (this.status === "error") col = "#000";

			return col;
		},
		placeholderCheck() {
			return this.placeholder || "E-mail address";
		},
		errorCheck() {
			return this.error || "There was an Issue signing up you into our mailing list. Please try again later.";
		},
	},
	methods: {
		clearSettings() {
			this.response = "";
			this.email = "";
			this.status = "";
		},
		onSubmit() {
			this.isSending = true;
			axios
				.post(this.axiosUrl, {
					email: this.email,
					language: this.language,
					langcode: this.currentLanguage,
				})
				.then((response) => {
					if (response.data.status === 200) {
						this.response = response.data.note;
						this.status = "success";
					} else {
						this.response = response.data.wrongEmail;
						this.status = "error";
					}
					this.isSending = false;
					setTimeout(() => {
						this.clearSettings();
					}, 5000);
				})
				.catch((error) => {
					console.log(error);
					this.isSending = false;
					this.status = "error";
					this.response = this.errorCheck;
					setTimeout(() => {
						this.clearSettings();
					}, 5000);
				});
		},
		onFocus() {
			this.isFocus = true;
		},
		onBlur() {
			this.isFocus = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
p {
	// color: $colorRed1 !important;
}
.label {
	@include mq($to: m) {
		display: none;
	}
}

form {
	margin-top: 8px;
	position: relative;
	padding-bottom: 25px;

	@include mq($from: m) {
		padding-bottom: 0;
	}

	&.is_sending {
		& > div {
			&:after {
				opacity: 1;
			}

			input {
				opacity: 0.75;
			}

			button {
				opacity: 0;
			}
		}
	}

	& > div {
		display: inline-block;
		position: relative;
		max-width: 272px;
		width: 100%;

		&:after {
			content: "";
			display: block;
			width: 20px;
			height: 20px;
			border: 1px solid #000;
			border-top: 0;
			border-radius: 50%;
			animation: spin 1s infinite linear;
			pointer-events: none;

			position: absolute;
			top: calc(50% - 10px);
			right: 10px;
			opacity: 0;
			transition: opacity 0.2s;
		}
	}

	button {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0, -50%);
		background: none;
		border: none;
		padding: 10px;
		transition: opacity 0.2s;
		cursor: pointer;

		svg {
			transform: translate(0, 1px);
		}
	}

	.tick {
		position: absolute;
		right: 10px;
		top: calc(50% + 1px);
		transform: translate(0, -50%);

		svg {
			width: 14px;
			height: 8px;
		}
	}
}

input[type="email"] {
	border: 0;
	background: transparent;
	color: #000 !important;
	border-radius: 3px;
	padding: 14px 15px;
	font-size: 14px;
	outline: none;
	// background-image: url("/images/inputbg.png");
	// background-size: contain;
	// background-position: left center;
	// background-repeat: no-repeat;
	width: 100%;
	transition: opacity 0.2s;
	position: relative;
	padding-right: 35px;

	&::placeholder {
		color: #000;
		opacity: 0.8;
	}

	& ~ svg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}

	&:focus {
	}
}
</style>
